import React, { useEffect, useRef } from "react";
import { Assignment, Check } from "@material-ui/icons";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import CardBody from "components/Card/CardBody";
import { Checkbox, FormControlLabel, makeStyles } from "@material-ui/core";
import { Link } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
import { bookingApi } from "functions/apis";
import ReactTable from "react-table";
import EditIcon from "@material-ui/icons/Edit";
import CustomInput from "components/CustomInput/CustomInput";
import { formatDateTime } from "functions/Helper";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { token } from "functions/Helper";
import PublishSharpIcon from "@material-ui/icons/PublishSharp";
import RemoveIcon from "@material-ui/icons/Remove";
import axios from "axios";

const useStyles = makeStyles(styles);

export default function MerchantPromo() {
  const classes = useStyles();
  const source = useRef(new AbortController());

  const [filter, setFilter] = React.useState({
    searchString: "",
    currentActive: false
  });
  const [data, setData] = React.useState([]);

  const [pagination, setPagination] = React.useState({
    pageIndex: 1,
    pageSize: 10
  });
  const [loading, setLoading] = React.useState(false);
  const [pages, setPages] = React.useState(0);

  const getDataMerchantPromo = () => {
    setLoading(true);
    bookingApi
      .get("MerchantPromos", {
        signal: source.current.signal,
        params: {
          filter,
          pagination
        }
      })
      .then(data => {
        setData(
          data.records.map(records => {
            return {
              ...records,
              merchantPromoBanner: records.isUploadBanner ? (
                <div className="actions-right">
                  <Button
                    color="info"
                    className="like"
                    onClick={() =>
                      axios
                        .get(
                          process.env.REACT_APP_BOOKING_API_URL +
                            "/MerchantPromos/Banner/" +
                            records.id,
                          {
                            responseType: "arraybuffer",
                            headers: {
                              Authorization: localStorage.getItem(
                                "Authorization"
                              )
                            }
                          }
                        )
                        .then(response => {
                          let filename = response.request
                            .getResponseHeader("Content-Disposition")
                            .split(";")[2]
                            .replace("filename*=UTF-8''", "");
                          const url = window.URL.createObjectURL(
                            new Blob([response.data])
                          );
                          const link = document.createElement("a");
                          link.href = url;
                          link.setAttribute("download", filename);
                          document.body.appendChild(link);
                          link.click();
                        })
                    }
                  >
                    Download
                  </Button>
                  <Link to={"/admin/MerchantPromo/RemoveBanner/" + records.id}>
                    <Button color="danger" className="like">
                      <RemoveIcon /> REMOVE BANNER
                    </Button>
                  </Link>
                </div>
              ) : (
                <div>NO FILE ATTACHED</div>
              ),
              merchantPartnerLogo: records.partnerLogo ? (
                <div className="actions-right">
                  <Button
                    color="info"
                    className="like"
                    onClick={() =>
                      axios
                        .get(
                          process.env.REACT_APP_BOOKING_API_URL +
                            "/MerchantPromos/PartnerLogo/" +
                            records.id,
                          {
                            responseType: "arraybuffer",
                            headers: {
                              Authorization: localStorage.getItem(
                                "Authorization"
                              )
                            }
                          }
                        )
                        .then(response => {
                          let filename = response.request
                            .getResponseHeader("Content-Disposition")
                            .split(";")[2]
                            .replace("filename*=UTF-8''", "");
                          const url = window.URL.createObjectURL(
                            new Blob([response.data])
                          );
                          const link = document.createElement("a");
                          link.href = url;
                          link.setAttribute("download", filename);
                          document.body.appendChild(link);
                          link.click();
                        })
                    }
                  >
                    DOWNLOAD
                  </Button>
                  <Link
                    to={"/admin/MerchantPromo/RemovePartnerLogo/" + records.id}
                  >
                    <Button color="danger" className="like">
                      <RemoveIcon /> REMOVE
                    </Button>
                  </Link>
                </div>
              ) : (
                <div>NO FILE ATTACHED</div>
              ),
              actions: (
                <div className="actions-right">
                  <>
                    <Link to={"/admin/MerchantPromo/Detail/" + records.id}>
                      <Button color="info" className="like">
                        <VisibilityIcon /> VIEW
                      </Button>
                    </Link>
                    {(token["booking.merchant_promos.write"] === "allowed" ||
                      token.is_admin === "True") && (
                      <Link to={"/admin/MerchantPromo/Edit/" + records.id}>
                        <Button
                          color="danger"
                          className="remove"
                          onClick={() => {}}
                        >
                          <EditIcon /> EDIT
                        </Button>
                      </Link>
                    )}
                    {(token["booking.merchant_promos.write"] === "allowed" ||
                      token.is_admin === "True") && (
                      <Link
                        to={"/admin/MerchantPromo/UploadBanner/" + records.id}
                      >
                        <Button color="info" className="like">
                          <PublishSharpIcon /> UPLOAD BANNER
                        </Button>
                      </Link>
                    )}
                    {(token["booking.merchant_promos.write"] === "allowed" ||
                      token.is_admin === "True") &&
                      records.isMegaMallPromo && (
                        <Link
                          to={
                            "/admin/MerchantPromo/UploadPartnerLogo/" +
                            records.id
                          }
                        >
                          <Button color="info" className="like">
                            <PublishSharpIcon /> UPLOAD LOGO
                          </Button>
                        </Link>
                      )}
                  </>
                </div>
              )
            };
          })
        );
        setPages(Math.ceil(data.totalRecords / pagination.pageSize));
      })
      .catch(err => console.log(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getDataMerchantPromo();

    return () => source.current.abort();
  }, []);

  useEffect(() => {
    getDataMerchantPromo();
  }, [filter, pagination]);

  const handleSearchStringChanged = e =>
    setFilter({
      ...filter,
      searchString: e.target.value === "" ? null : e.target.value
    });

  const handleCurrentActiveChanged = e =>
    setFilter({
      ...filter,
      currentActive: e.target.checked
    });

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Merchant Promo</h4>
          </CardHeader>
          <CardBody>
            {(token["booking.merchant_promos.write"] === "allowed" ||
              token.is_admin === "True") && (
              <Link to={"/admin/MerchantPromo/Create"}>
                <Button color="rose" type="button" value="Create">
                  Create
                </Button>
              </Link>
            )}

            <GridItem xs={3}>
              <CustomInput
                labelText="Search"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: handleSearchStringChanged,
                  value: filter.searchString === null ? "" : filter.searchString
                }}
              />
            </GridItem>
            <GridItem>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={filter.currentActive}
                    onChange={handleCurrentActiveChanged}
                    checkedIcon={<Check className={classes.checkedIcon} />}
                    icon={<Check className={classes.uncheckedIcon} />}
                    classes={{
                      checked: classes.checked,
                      root: classes.checkRoot
                    }}
                  />
                }
                classes={{
                  label: classes.label,
                  root: classes.labelRoot
                }}
                label="Current Active"
              />
              <ReactTable
                manual
                pages={pages}
                page={pagination.pageIndex - 1}
                pageSize={pagination.pageSize}
                onPageChange={page =>
                  setPagination({
                    pageIndex: page + 1,
                    pageSize: pagination.pageSize
                  })
                }
                onPageSizeChange={(pageSize, page) => {
                  setPagination({ pageSize: pageSize, pageIndex: page + 1 });
                }}
                loading={loading}
                data={data}
                filterable={false}
                columns={[
                  {
                    id: "title",
                    Header: "Title",
                    accessor: d => d.title
                  },
                  // {
                  //   id: "description",
                  //   Header: "Description",
                  //   accessor: d => d.description
                  // },
                  {
                    id: "limit",
                    Header: "Limit",
                    accessor: d => d.limit
                  },
                  {
                    id: "used",
                    Header: "Used",
                    accessor: d => d.used
                  },
                  {
                    id: "merchant",
                    Header: "Merchant",
                    accessor: d => d.merchant.code
                  },
                  {
                    id: "effectiveDate",
                    Header: "Effective Date",
                    accessor: d =>
                      formatDateTime(new Date(d.effectiveDate + "Z"))
                  },
                  {
                    id: "expiryDate",
                    Header: "Expiry Date",
                    accessor: d =>
                      d.expiryDate === null
                        ? ""
                        : formatDateTime(new Date(d.expiryDate + "Z"))
                  },
                  {
                    Header: "Banner File",
                    accessor: "merchantPromoBanner"
                  },
                  {
                    Header: "Partner Logo",
                    accessor: "merchantPartnerLogo"
                  },
                  {
                    Header: "Actions",
                    accessor: "actions",
                    sortable: false,
                    filterable: false
                  }
                ]}
                defaultPageSize={10}
                showPaginationTop
                showPaginationBottom={false}
                className="-striped -highlight"
              />
            </GridItem>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
